import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"   viewBox="0 0 1024.000000 1280.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)">

<path d="M1765 12707 c-151 -107 -159 -113 -325 -237 -264 -198 -470 -370
-740 -616 -242 -220 -593 -591 -688 -725 -9 -14 -12 -96 -10 -358 l3 -339 110
106 c290 281 476 440 791 678 367 277 768 537 1229 799 126 71 141 79 368 204
143 79 388 206 732 381 209 106 382 195 384 196 2 2 -385 4 -860 4 l-864 -1
-130 -92z"/>
<path d="M7555 8354 c-421 -75 -744 -383 -851 -813 -13 -53 -24 -111 -24 -128
0 -33 0 -33 50 -33 56 0 49 -10 71 113 9 54 16 70 33 77 17 7 198 40 220 40 3
0 5 -51 4 -112 l-3 -113 45 3 c25 2 48 8 51 14 3 5 9 57 12 114 3 58 7 107 9
109 5 5 397 78 427 79 23 1 26 -6 51 -109 56 -228 69 -290 62 -296 -4 -3 -41
-12 -82 -18 -41 -7 -76 -14 -78 -16 -2 -2 4 -24 13 -50 14 -35 22 -44 35 -40
34 11 134 25 139 19 3 -3 20 -67 38 -142 52 -219 63 -273 58 -282 -2 -4 -23
-10 -45 -14 -45 -7 -46 -9 -25 -61 15 -36 17 -36 62 -33 l46 3 48 -188 c26
-104 50 -191 53 -194 3 -3 24 2 46 12 32 14 39 22 35 39 -3 12 -23 95 -45 186
-21 90 -37 166 -34 169 8 9 318 91 323 86 2 -3 -4 -44 -14 -92 -20 -97 -60
-214 -100 -293 l-26 -51 38 20 c102 52 116 70 156 192 20 63 42 139 47 169 6
30 13 65 15 76 4 17 27 29 110 59 58 21 108 35 111 32 13 -13 -76 -219 -128
-297 -21 -32 -16 -29 58 28 124 96 138 114 173 225 118 372 72 728 -135 1049
-51 79 -166 203 -246 264 -221 171 -530 247 -803 198z m250 -159 c39 -19 93
-55 122 -80 52 -45 153 -171 153 -190 0 -12 -285 -78 -343 -79 l-41 -1 -42
177 c-23 97 -44 183 -47 191 -9 25 5 29 68 23 38 -4 86 -19 130 -41z m409 -78
c62 -39 166 -125 166 -136 0 -5 -41 -17 -92 -26 -70 -14 -93 -15 -96 -6 -8 24
-124 173 -167 215 -25 23 -45 45 -45 48 0 12 186 -63 234 -95z m-663 -102 c25
-105 45 -193 43 -196 -9 -17 -379 -87 -392 -75 -9 10 55 198 95 276 51 100
148 196 193 187 10 -1 28 -58 61 -192z m-364 3 c-39 -81 -81 -203 -92 -261 -4
-21 -13 -40 -19 -42 -18 -7 -211 -33 -214 -30 -2 2 6 22 18 45 64 125 162 242
270 321 35 26 66 46 68 44 2 -2 -12 -36 -31 -77z m1330 -190 c22 -35 51 -83
63 -108 27 -52 70 -176 70 -200 0 -13 -28 -23 -130 -47 l-130 -30 -10 41 c-20
78 -72 231 -101 294 -20 45 -25 64 -16 68 10 3 177 38 207 43 3 1 24 -27 47
-61z m-335 -85 c32 -70 85 -224 102 -294 5 -25 3 -27 -52 -39 -31 -7 -82 -19
-112 -27 -106 -27 -292 -64 -297 -60 -2 3 -15 51 -28 108 -13 57 -33 148 -46
201 -12 54 -20 100 -18 102 4 3 385 84 405 85 6 1 27 -34 46 -76z m505 -360
c10 -39 10 -224 0 -305 l-8 -66 -97 -36 c-53 -19 -109 -38 -123 -41 l-26 -6 0
138 c-1 76 -6 169 -12 207 -7 38 -10 70 -8 73 4 4 181 47 227 56 14 2 28 5 32
6 4 0 11 -11 15 -26z m-370 -153 c13 -94 15 -231 5 -300 l-7 -45 -148 -42
c-82 -24 -166 -46 -187 -49 l-38 -6 -11 48 c-6 27 -26 119 -46 204 -19 85 -35
162 -35 170 0 12 37 24 158 49 86 19 182 40 212 47 84 19 83 20 97 -76z"/>
<path d="M9211 8035 c-30 -9 -57 -17 -59 -19 -2 -2 20 -11 48 -19 94 -28 148
-80 176 -173 8 -26 14 -65 14 -86 0 -52 -27 -178 -54 -258 -24 -68 -108 -234
-132 -261 -8 -8 -14 -19 -14 -23 0 -8 -78 -113 -169 -229 -71 -89 -315 -324
-434 -417 -141 -111 -381 -274 -504 -343 -336 -187 -750 -349 -1028 -402 -207
-40 -413 -15 -481 57 -47 49 -57 75 -64 158 l-6 75 -34 -70 c-83 -170 -33
-325 125 -385 50 -20 84 -24 208 -28 159 -5 243 4 422 44 511 115 1058 383
1555 763 105 80 403 376 494 491 146 184 270 402 333 585 23 70 27 96 27 205
1 111 -2 130 -22 172 -33 68 -94 123 -160 148 -75 28 -172 34 -241 15z"/>
<path d="M4808 7338 c-43 -9 -99 -28 -125 -42 -194 -99 -240 -380 -87 -529 58
-56 135 -91 307 -141 190 -54 229 -72 241 -108 48 -139 -206 -157 -448 -33
-49 25 -90 44 -91 43 -1 -2 -26 -48 -55 -103 -29 -55 -57 -106 -63 -114 -15
-18 5 -32 118 -87 131 -62 188 -76 352 -81 168 -6 249 9 340 63 104 61 155
135 175 254 11 62 10 80 -5 136 -31 119 -96 182 -250 244 -41 16 -81 30 -89
30 -27 1 -238 68 -262 84 -29 18 -41 54 -32 90 22 87 224 85 403 -5 l74 -37
16 32 c33 65 76 142 94 172 l19 31 -87 38 c-49 20 -95 41 -105 46 -62 32 -331
42 -440 17z"/>
<path d="M1048 7342 l-158 -3 0 -380 c0 -314 3 -392 16 -442 22 -86 55 -147
119 -215 147 -159 425 -214 667 -131 175 61 296 201 327 380 14 84 15 786 1
791 -5 2 -84 2 -174 0 l-165 -3 -3 -388 -3 -388 -30 -49 c-63 -102 -198 -134
-295 -69 -28 19 -53 48 -69 80 l-26 49 -3 383 c-2 211 -7 383 -12 383 -4 0
-14 1 -22 3 -7 1 -84 1 -170 -1z"/>
<path d="M2459 7346 c-3 -3 -73 -6 -157 -7 l-151 -2 -1 -589 0 -588 170 0 170
0 0 163 0 162 58 64 58 65 76 -110 c42 -60 114 -161 160 -224 l84 -115 326 -3
326 -2 38 110 39 110 224 -2 224 -3 40 -107 39 -108 165 0 c128 0 164 3 160
13 -88 223 -213 530 -317 777 -73 173 -139 332 -148 353 l-15 37 -152 0 -152
0 -71 -172 c-38 -95 -96 -234 -127 -308 -78 -187 -225 -558 -237 -597 -5 -18
-12 -33 -16 -33 -5 0 -32 34 -62 75 -30 42 -111 151 -180 243 -69 93 -144 194
-167 226 l-43 58 61 72 c34 39 136 153 226 254 91 101 164 184 162 185 -2 1
-92 0 -199 -3 l-194 -5 -186 -222 c-102 -122 -188 -222 -192 -222 -4 -1 -9
101 -10 226 -3 209 -8 250 -29 229z m1446 -443 c11 -32 39 -107 62 -167 24
-60 43 -111 43 -113 0 -1 -56 -3 -125 -3 -80 0 -125 4 -125 10 0 9 82 252 105
313 12 28 20 20 40 -40z"/>
<path d="M5567 7333 c-1 -1 -1 -165 0 -365 0 -199 2 -463 2 -585 l1 -223 155
0 155 0 0 229 0 230 54 6 c30 4 130 5 223 3 l168 -3 3 -233 2 -232 160 0 160
0 0 590 0 590 -160 0 -160 0 0 -230 0 -231 -222 3 -223 3 -5 226 -5 225 -153
0 c-85 -1 -154 -2 -155 -3z"/>
<path d="M7124 7318 c-3 -13 -45 -120 -91 -238 -183 -465 -257 -650 -308 -780
l-54 -135 152 -5 c84 -3 157 -4 162 -2 6 1 26 46 44 100 19 53 38 103 44 110
7 9 61 12 208 12 231 0 209 12 255 -132 15 -49 33 -88 39 -88 216 -6 325 -3
325 7 0 15 -105 287 -323 838 -63 160 -118 300 -121 313 -7 22 -10 22 -166 22
-156 0 -159 0 -166 -22z m167 -385 c24 -62 109 -307 109 -315 0 -4 -54 -8
-120 -8 -66 0 -120 4 -120 9 0 5 22 70 49 145 27 74 52 149 56 166 8 37 13 38
26 3z"/>
<path d="M2690 5265 l0 -235 121 0 c67 0 139 5 160 12 52 15 117 73 140 122
20 45 25 131 9 186 -13 45 -62 97 -114 121 -43 19 -83 27 -58 10 10 -6 7 -10
-11 -13 -20 -4 -23 -1 -19 14 4 17 -4 18 -112 18 l-116 0 0 -235z m260 137
c49 -24 83 -92 76 -150 -12 -89 -69 -132 -176 -132 l-60 0 0 150 0 150 63 0
c39 0 75 -6 97 -18z"/>
<path d="M3431 5457 c-47 -110 -153 -355 -166 -385 -8 -18 -15 -36 -15 -40 0
-4 23 -7 52 -7 l52 0 21 53 20 52 103 0 103 0 21 -50 21 -50 53 0 c30 0 54 2
54 5 0 5 -123 289 -170 393 l-33 72 -49 0 c-48 0 -49 -1 -67 -43z m103 -148
c14 -36 26 -71 26 -77 0 -12 -111 -18 -122 -6 -3 3 8 41 26 84 17 43 34 76 37
72 4 -4 19 -37 33 -73z"/>
<path d="M3820 5460 l0 -40 75 0 75 0 0 -200 0 -201 28 5 c15 2 37 5 50 5 l22
1 0 195 0 195 75 0 75 0 0 40 0 40 -200 0 -200 0 0 -40z"/>
<path d="M4480 5473 c-27 -59 -178 -409 -184 -428 -5 -19 -2 -20 50 -15 56 5
56 5 73 50 l17 45 104 3 105 3 20 -50 c22 -58 31 -63 87 -55 30 5 38 11 35 23
-8 25 -138 323 -181 414 -17 35 -21 37 -66 37 -41 0 -48 -3 -60 -27z m93 -161
c15 -37 27 -73 27 -80 0 -13 -120 -18 -120 -4 -1 14 55 152 61 152 3 0 18 -30
32 -68z"/>
<path d="M5227 5333 c-4 -91 -7 -197 -7 -235 l0 -68 55 0 55 0 0 95 0 95 95 0
c52 0 98 -1 102 -2 5 -2 6 -45 4 -95 l-3 -93 56 0 56 0 0 235 0 235 -50 0 -49
0 -3 -92 -3 -93 -101 -3 -101 -3 -7 32 c-3 17 -6 60 -6 95 l0 64 -43 0 -44 0
-6 -167z"/>
<path d="M5831 5338 c1 -180 7 -212 57 -262 78 -80 242 -73 314 12 37 45 50
118 46 276 l-3 136 -46 0 -47 0 -7 -157 c-9 -200 -20 -223 -101 -223 -98 0
-114 33 -114 235 l0 145 -50 0 -50 0 1 -162z"/>
<path d="M6430 5265 l0 -235 145 0 c167 0 212 12 245 65 35 57 18 128 -40 164
l-30 18 25 21 c30 26 39 60 32 110 -12 72 -65 92 -249 92 l-128 0 0 -235z
m261 145 c23 -13 26 -62 3 -84 -11 -12 -36 -16 -90 -16 l-74 0 0 55 0 55 71 0
c39 0 79 -5 90 -10z m9 -193 c19 -10 25 -20 25 -47 0 -47 -29 -61 -120 -58
l-70 3 -3 44 c-2 24 -1 50 2 57 7 18 131 19 166 1z"/>
<path d="M1622 5268 l3 -33 205 -2 c113 -1 296 1 408 4 l202 5 0 29 0 29 -411
0 -410 0 3 -32z"/>
<path d="M7072 5268 l3 -33 400 0 400 0 3 33 3 32 -406 0 -406 0 3 -32z"/>
<path d="M10110 2507 c-430 -419 -1013 -832 -1625 -1152 -71 -37 -138 -75
-147 -83 -10 -8 -18 -12 -18 -9 0 9 -137 -61 -145 -73 -4 -6 -10 -8 -15 -5
-11 7 -32 -30 -23 -38 3 -4 -2 -9 -11 -13 -9 -3 -13 -11 -10 -16 4 -5 -3 -23
-15 -39 -14 -19 -21 -43 -21 -74 0 -25 -4 -45 -9 -45 -17 0 -71 -61 -71 -80 0
-19 -54 -80 -71 -80 -5 0 -9 -8 -9 -18 0 -22 -40 -62 -61 -62 -14 0 -59 -58
-59 -76 0 -10 -53 -68 -73 -81 -7 -4 -23 -25 -36 -45 -12 -21 -28 -38 -35 -38
-14 0 -86 -74 -86 -88 0 -6 -17 -24 -38 -41 -24 -18 -43 -45 -52 -70 -7 -23
-19 -41 -27 -41 -7 0 -13 -4 -13 -9 0 -12 -59 -71 -71 -71 -5 0 -9 -3 -9 -8 0
-4 -18 -15 -40 -25 -38 -16 -45 -25 -41 -55 1 -7 -9 -22 -23 -33 -14 -11 -26
-25 -26 -30 0 -5 106 -9 258 -9 l257 0 150 69 c244 111 380 181 720 369 55 31
111 63 125 73 14 9 48 29 75 45 87 48 434 276 495 324 42 33 48 22 8 -15 -21
-19 -34 -35 -29 -35 5 0 14 7 21 15 7 8 18 15 25 15 14 0 29 28 26 46 -1 6 10
11 24 11 14 1 25 -3 25 -8 0 -5 -5 -9 -11 -9 -5 0 -7 -4 -4 -10 3 -6 -1 -7 -9
-4 -19 7 -39 -37 -29 -63 6 -15 4 -16 -9 -5 -10 8 -19 9 -22 3 -3 -5 0 -12 6
-14 10 -4 10 -6 1 -6 -8 -1 -13 -16 -13 -41 0 -27 -4 -40 -13 -40 -20 0 -79
-68 -71 -81 3 -6 -3 -24 -15 -40 -11 -15 -21 -33 -21 -40 0 -16 -36 -60 -43
-52 -4 3 -4 -18 0 -46 6 -51 5 -53 -38 -97 -30 -30 -51 -44 -70 -44 -22 0 -31
-8 -46 -40 -10 -22 -24 -40 -30 -40 -7 0 -13 -7 -13 -15 0 -17 -46 -65 -63
-65 -11 0 -57 -86 -57 -108 0 -5 -9 -12 -20 -15 -11 -3 -20 -12 -20 -21 0 -14
68 -16 720 -16 l720 0 0 1315 c0 723 -1 1315 -2 1315 -2 -1 -59 -56 -128 -123z
m-1950 -1377 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4
-10z m1330 -129 c0 -4 -19 -21 -42 -37 -61 -41 -68 -46 -68 -40 0 4 100 84
108 85 1 1 2 -3 2 -8z m-50 -77 c0 -8 -4 -12 -10 -9 -5 3 -10 10 -10 16 0 5 5
9 10 9 6 0 10 -7 10 -16z"/>
<path d="M8065 1141 c-22 -11 -36 -20 -32 -20 12 -1 77 27 77 33 0 8 0 8 -45
-13z"/>
<path d="M7981 1101 c-11 -7 -11 -9 0 -14 10 -4 10 -6 2 -6 -17 -1 -17 -17 0
-24 8 -3 12 5 12 24 1 16 1 29 0 29 0 0 -6 -4 -14 -9z"/>
<path d="M7930 1080 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M7890 1060 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M7800 1020 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M9250 710 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
